import type { ComponentType } from 'react'

export const lazy = (importFn: () => Promise<Record<string, unknown>>) => () =>
  importFn()
    .catch((): Record<string, unknown> => {
      window.location.reload()
      return { default: () => null }
    })
    .then((m) => ({
      Component:
        (m['default'] as ComponentType | undefined) ??
        (Object.values(m).find((v) => typeof v === 'function') as ComponentType | undefined) ??
        null,
      ...(m['handle'] !== undefined && { handle: m['handle'] }),
    }))
